import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-pie-icon',
    templateUrl: './pie-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PieIconComponent {}
